import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import StatisticsByReactivationContentComponent from './StatisticsByReactivationContent/StatisticsByReactivationContent.container';
import { withRouter } from '../../RouterCompatibility.js';

const StatisticsByReactivationPage = ({ t, location }) => {
    const staticNames = t?.reportPage || {};

    return (
        <div className="dashboard dashboard_consolidated-report">
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.titleByReactivation}</h2>
                </div>
            </div>

            <StatisticsByReactivationContentComponent
                location={location}
            />
        </div>
    );
};

StatisticsByReactivationPage.propTypes = {
    t: PropTypes.object,
    location: PropTypes.object
};

StatisticsByReactivationPage.defaultProps = {
    t: {},
    location: {}
};

export default withRouter(withTranslation(StatisticsByReactivationPage));